import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Button, ImageAtoms } from "@vfit/shared/atoms";
import { Title, Description, ButtonContainer, ExternalContainer, ImageContainer } from "./rectangleBackground.style";
var rectangleBackground = function(param) {
    var containerRef = param.containerRef, data = param.data, handleClick = param.handleClick, children = param.children;
    var title = data.title, description = data.description, ctaLabel = data.ctaLabel, backgroundImage = data.backgroundImage, isExternalImages = data.isExternalImages;
    return /*#__PURE__*/ _jsxs(ExternalContainer, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ImageContainer, {
                        children: /*#__PURE__*/ _jsx(ImageAtoms, {
                            objectFit: "cover",
                            style: {
                                position: "absolute",
                                borderRadius: "15px"
                            },
                            image: backgroundImage,
                            nameCard: title,
                            external: isExternalImages
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            position: "relative",
                            paddingTop: 80
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                children: title
                            }),
                            /*#__PURE__*/ _jsxs(Description, {
                                children: [
                                    " ",
                                    description,
                                    " "
                                ]
                            }),
                            !!ctaLabel && /*#__PURE__*/ _jsx(ButtonContainer, {
                                children: /*#__PURE__*/ _jsx(Button, {
                                    variant: "secondary",
                                    onClick: handleClick,
                                    children: ctaLabel
                                })
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
export default rectangleBackground;
